export default __webpack_public_path__ + "static/6889-600e9c3e349978028874e33adaa2a4b7.jpg";